export enum ImageUploadType {
    ANIMAL_IMAGE,
    SPONSOR,
    NONE
}
